import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useDeleteRecordMutation } from "../api/managementApi";
import { namespaces } from "../consts/i18n";
import useAuthInfo from "../hooks/useAuthInfo";
import { DimensionType } from "../api/dimensionType";
import IconButton from "./buttons/IconButton";
import EditRecordDialog from "./dialogs/EditRecordDialog";
import MessageDialog from "./dialogs/MessageDialog";

function RecordListItem({ record }) {
  const [deleteRecord] = useDeleteRecordMutation();

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [isOpenEditRecordDialog, setIsOpenEditRecordDialog] = useState(false);

  const { t } = useTranslation(namespaces.viewer);

  const { isDemoUser, isStateLinkLevel } = useAuthInfo();

  const canEdit = !isDemoUser && !isStateLinkLevel; // useSelector((state) => state.auth?.me?.isAdmin);

  const handleDeleteRecord = () => {
    setDeleteDialogOpen(true);
  };

  const handleEditRecord = () => {
    setIsOpenEditRecordDialog(true);
  };

  const handleDeleteRecordSubmit = () => {
    deleteRecord({
      id: record.id,
      dimension: DimensionType.D2,
    });
    setDeleteDialogOpen(false);
  };

  return (
    <div className="flex justify-between items-center px-5 py-2">
      <div className="flex text-black font-bold text-700 justify-center items-center text-xl">
        {record.name}
      </div>
      <div className="flex flex-row gap-2">
        <IconButton
          icon="/images/sidebar_record_detail.svg"
          size={24}
          onClick={handleEditRecord}
        />

        {canEdit && (
          <IconButton
            icon="/images/trash.svg"
            size={24}
            onClick={handleDeleteRecord}
          />
        )}
      </div>
      <EditRecordDialog
        isOpen={isOpenEditRecordDialog}
        onClose={() => {
          setIsOpenEditRecordDialog(false);
        }}
        recordId={record.id}
      />
      <MessageDialog
        isOpen={deleteDialogOpen}
        title={t("deleteRecordDialog.title")}
        onCancel={() => setDeleteDialogOpen(false)}
        onSubmit={handleDeleteRecordSubmit}
        cancelText={t("deleteRecordDialog.cancel")}
        submitText={t("deleteRecordDialog.delete")}
      />
    </div>
  );
}

export default RecordListItem;
